export { ControllingDashboard as default } from "./controlling-dashboard";
